import React, { useContext, useEffect, useRef, useState } from "react";
import _ from "lodash";

import makeStyles from '@mui/styles/makeStyles';
import Typography from "@mui/material/Typography";
import { Container } from "@mui/material";
import Grid from "@mui/material/Grid";

import LanguageContext from "../../LanguageContext";
import messages from "../../services/messages";
import Skeleton from '@mui/material/Skeleton';
import SectionTitle from "../SectionTitle";
import ContentVideoCard from "../ContentVideoCard";
import Button from "@mui/material/Button";
import { ExpandMore } from "@mui/icons-material";

const useStyles = makeStyles((theme) => ({
  root: {
    // display: "flex",
    marginTop: theme.spacing(4),
  },
  container: {
    // margin:theme.spacing(-1)
    // border:'solid',
    // borderWidth:'2px',
    // borderColor:'lightgrey'
  },
  contentCard: {
    marginLeft: theme.spacing(2),
  },
  contentVideoSeeMore: {
    background: "#FFFFFF",
    marginTop: theme.spacing(2),
    color: "#9D2123",
    borderColor: "#9D2123",
  },
}));

export default function CropContentVideosContainer(props) {
  const classes = useStyles();
  const language = useContext(LanguageContext);
  const scrollToRef = useRef(null);
  const [videosPlaylist, setVideosPlaylist] = useState(null);
  const [contentVideos, setContentVideos] = useState(null);
  const executeScroll = () => {
    if (scrollToRef && scrollToRef.current) {
      scrollToRef.current.scrollIntoView();
    }
  };

  useEffect(() => {
    if (
      props.contentVideos &&
      props.contentVideos.length > 0 &&
      props.currentWeeksAfterSowing
    ) {
      executeScroll();
    }
  }, [props.contentVideos, props.currentWeeksAfterSowing]);

  useEffect(() => {
    if (props.contentVideos && props.contentVideos.length > 0) {
      let videosPlaylistVar = [];
      for (let i = 0; i < props.contentVideos.length; i++) {
        if (props.contentVideos[i] && props.contentVideos[i].youtube_id) {
          videosPlaylistVar[
            i
          ] = `https://www.youtube-nocookie.com/embed/${props.contentVideos[i].youtube_id}?autoplay=1&rel=0&modestbranding=1&enablejsapi=1&frameborder=0&hl=${language}`;
        }
      }
      setVideosPlaylist(videosPlaylistVar);
      setContentVideos(props.contentVideos);
    }
  }, [props.contentVideos]);

  return (
    <div className={classes.root}>
      <Container className={classes.container}>
        <SectionTitle
          icon={"icons/content-video.svg"}
          title={messages["cropPage.contentVideo.sectionTitle"][language]}
        />
        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="flex-start"
          spacing={1}
        >
          {_.map(props.visibleContentVideos, (contentVideo, index) => {
            return (
              <>
                {contentVideo &&
                  contentVideo.youtube_id &&
                  videosPlaylist &&
                  videosPlaylist.length > 0 && (
                    <Grid item xs={12} sm={12} md={6} lg={4} key={index}>
                      {contentVideo && contentVideo.youtube_id && (
                        <ContentVideoCard
                          mobile={props.mobile}
                          contentVideo={contentVideo}
                          position={index + 1}
                          userType={props.userType}
                          farmerCrops={props.farmerCrops}
                          userSource={props.userSource}
                          userState={props.userState}
                          contentVideos={contentVideos.slice(
                            contentVideos
                              .map(function (e) {
                                return e.youtube_id;
                              })
                              .indexOf(contentVideo.youtube_id),
                            contentVideos.length
                          )}
                          videosPlaylist={videosPlaylist.slice(
                            videosPlaylist.indexOf(
                              `https://www.youtube-nocookie.com/embed/${contentVideo.youtube_id}?autoplay=1&rel=0&modestbranding=1&enablejsapi=1&frameborder=0&hl=${language}`
                            ),
                            videosPlaylist.length
                          )}
                        />
                      )}
                    </Grid>
                  )}
              </>
            );
          })}

          {props.contentVideos &&
            props.contentVideos.length > props.defaultVisibleCount &&
            props.visibleContentVideos.length < props.contentVideos.length && (
              <Grid
                container
                direction="row"
                justifyContent="space-around"
                alignItems="center"
                spacing={1}
              >
                <Grid>
                  <Button
                    onClick={props.setVisible}
                    variant={"outlined"}
                    className={classes.contentVideoSeeMore}
                  >
                    {messages["cropPage.contentVideo.seeMore"][language]}
                    <ExpandMore />
                  </Button>
                </Grid>
              </Grid>
            )}

          {props.loading && (
            <>
              <Grid item xs={12} sm={12} md={6} lg={4}>
                <Skeleton variant="rectangular" height={100} />
              </Grid>
            </>
          )}

          {!props.loading && _.isEmpty(props.contentVideos) && (
            <Grid item xs={12} sm={12} md={12}>
              <Typography variant={"body2"}>No videos.</Typography>
            </Grid>
          )}
        </Grid>
      </Container>
    </div>
  );
}
